export const UsersRoutes = {
    Base: '/users',
    RegisterUser: 'register-user',
    Details: ':id',
};
